import { render, staticRenderFns } from "./copiarExames.vue?vue&type=template&id=e2a20c84&"
import script from "./copiarExames.vue?vue&type=script&lang=js&"
export * from "./copiarExames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports